"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MorningStarIncRebalanced = void 0;
var Tags_1 = require("../../Tags");
var Card_1 = require("../../Card");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var CardRenderer_1 = require("../../render/CardRenderer");
var GlobalParameter_1 = require("../../../GlobalParameter");
var Size_1 = require("../../render/Size");
var MorningStarIncRebalanced = (function (_super) {
    __extends(MorningStarIncRebalanced, _super);
    function MorningStarIncRebalanced() {
        return _super.call(this, {
            name: CardName_1.CardName.MORNING_STAR_INC_REBALANCED,
            tags: [Tags_1.Tags.VENUS],
            startingMegaCredits: 50,
            cardType: CardType_1.CardType.CORPORATION,
            initialActionText: 'Draw 3 Venus-tag cards',
            cardDiscount: { tag: Tags_1.Tags.VENUS, amount: 2 },
            metadata: {
                cardNumber: 'R06',
                description: 'You start with 50 M€. As your first action, reveal cards from the deck until you have revealed 3 Venus-tag cards. Take those into hand and discard the rest.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.megacredits(50).nbsp.cards(3).secondaryTag(Tags_1.Tags.VENUS);
                    b.corpBox('effect', function (ce) {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect('Your Venus requirements are +/- 3 steps, your choice in each case.', function (eb) {
                            eb.plate('Venus requirements').startEffect.text('+/- 3');
                        });
                        ce.effect('When you play a Venus tag, you pay 2 M€ less for it.', function (eb) {
                            eb.venus(1).played.startEffect.megacredits(-2);
                        });
                    });
                }),
            },
        }) || this;
    }
    MorningStarIncRebalanced.prototype.initialAction = function (player) {
        player.drawCard(3, { tag: Tags_1.Tags.VENUS });
        return undefined;
    };
    MorningStarIncRebalanced.prototype.getCardDiscount = function (_player, card) {
        return card.tags.filter(function (tag) { return tag === Tags_1.Tags.VENUS; }).length * 2;
    };
    MorningStarIncRebalanced.prototype.getRequirementBonus = function (_player, parameter) {
        return parameter === GlobalParameter_1.GlobalParameter.VENUS ? 3 : 0;
    };
    MorningStarIncRebalanced.prototype.play = function () {
        return undefined;
    };
    return MorningStarIncRebalanced;
}(Card_1.Card));
exports.MorningStarIncRebalanced = MorningStarIncRebalanced;
//# sourceMappingURL=MorningStarIncRebalanced.js.map